// @need-translate
import isNil from 'lodash/isNil';
import {t, tt} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {getPeriodText} from '../../../common/shared/utils/getPeriodText';
import {getRemainText} from '../../../common/shared/utils/getRemainText';
import {twMerge} from '../../../common/twMerge';
import {TextTKey} from '../../../common/type';
import {useContentHomeWaitFreeDialog} from '../../../domain/content/[seriesId]/hook/useContentHomeWaitFreeDialog';
import {isWaitfreeBm} from '../../../domain/content/[seriesId]/util/isWaitfreeBm';
import {TicketKind} from '../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {LabelBadge} from '../../molecules/LabelBadge/LabelBadge';
import {LabelBadge28Type} from '../../molecules/LabelBadge/LabelBadge28Type.enum';
import {LabelBadgeSizeType} from '../../molecules/LabelBadge/LabelBadgeSizeType.enum';
import {WaitfreeProgressBar} from '../../molecules/WaitfreeProgressbar/WaitfreeProgressBar';
import {
  ContentHomeTicketButtonProps,
  WaitfreeProps,
} from './ContentHomeTicketButtonProps.interface';
import {ContentHomeTicketButtonType} from './ContentHomeTicketButtonType.enum';
import {getRatio} from './getRatio';

export function ContentHomeTicketButton({
  isMobile,
  ticketButtonType,
  ownTicketCount,
  rentalTicketCount,
  giftTicketCount,
  giftTicketKind,
  onClickTicket,
  onClickButton,
  buttonEventLog,
  waitfreeProps,
  className,
}: ContentHomeTicketButtonProps) {
  if (ticketButtonType === ContentHomeTicketButtonType.StopText) {
    return (
      <div
        className={twMerge(
          'flex h-48pxr items-center justify-center rounded-8pxr bg-theme-solid-10 px-18pxr',
          className
        )}
      >
        <Text
          className={twMerge(
            isMobile ? 'font-small1' : 'font-small2',
            'text-static-point-red'
          )}
        >
          {t('contenthome_ep_tab_nosale')}
        </Text>
      </div>
    );
  }
  return (
    <div
      className={twMerge(
        isMobile && 'rounded-8pxr bg-theme-solid-10',
        !isMobile &&
          'rounded-6pxr border border-theme-transparent-20 bg-theme-bg-base'
      )}
    >
      <div
        className={twMerge(
          'flex h-48pxr items-center justify-between px-18pxr',
          !isMobile && 'pl-16pxr pr-12pxr',
          className
        )}
      >
        {(ticketButtonType === ContentHomeTicketButtonType.Ticket ||
          ticketButtonType === ContentHomeTicketButtonType.Refund) && (
          <div
            className={twMerge(
              'flex cursor-pointer items-center',
              isMobile && 'space-x-4pxr',
              !isMobile && 'space-x-2pxr'
            )}
            onClick={onClickTicket}
          >
            <div className="flex flex-wrap text-theme-solid-100">
              <Text
                className={twMerge(
                  'mr-4pxr text-theme-solid-100',
                  isMobile && 'font-small1-bold',
                  !isMobile && 'font-small2-bold'
                )}
              >
                {t('common_ticket_rental')}
              </Text>
              <Text
                className={twMerge(
                  'opacity-70',
                  isMobile && 'font-small1',
                  !isMobile && 'font-small2'
                )}
              >
                {t('common_ticket_amount', {
                  values: {
                    value: isNil(rentalTicketCount)
                      ? '0'
                      : formatWithCommas(rentalTicketCount),
                  },
                })}
              </Text>
            </div>
            <Icon type={IconType.ContentHomeListDivider} disableActiveEffect />
            <div className="flex flex-wrap text-theme-solid-100">
              <Text
                className={twMerge(
                  'mr-4pxr text-theme-solid-100',
                  isMobile && 'font-small1-bold',
                  !isMobile && 'font-small2-bold'
                )}
              >
                {t('common_ticket_possession')}
              </Text>
              <Text
                className={twMerge(
                  'opacity-70',
                  isMobile && 'font-small1',
                  !isMobile && 'font-small2'
                )}
              >
                {t('common_ticket_amount', {
                  values: {
                    value: isNil(ownTicketCount)
                      ? '0'
                      : formatWithCommas(ownTicketCount),
                  },
                })}
              </Text>
            </div>
            <Icon
              className="mx-6pxr!"
              type={IconType.ContentHomeMoreLine}
              disableActiveEffect
            />
          </div>
        )}

        {ticketButtonType === ContentHomeTicketButtonType.Gift && (
          <div className="flex items-center space-x-4pxr">
            <Text
              className={twMerge(
                'text-theme-solid-100',
                isMobile && 'font-small1-bold',
                !isMobile && 'font-small2-bold'
              )}
            >
              {`선물 ${
                giftTicketKind === TicketKind.Own
                  ? '소장권'
                  : giftTicketKind === TicketKind.Rent
                    ? '대여권'
                    : ''
              }`}
            </Text>
            <Text className="font-small1 text-theme-solid-100 opacity-70">
              {t('common_ticket_amount', {
                values: {
                  value: isNil(giftTicketCount)
                    ? '0'
                    : formatWithCommas(giftTicketCount),
                },
              })}
            </Text>
          </div>
        )}
        <LabelBadge
          sizeType={LabelBadgeSizeType.Size28}
          type={TICKET_BUTTON_LABEL_BADGE_TYPE_MAP[ticketButtonType]}
          className="ml-12px"
          labelClassName="text-center break-keep w-max"
          label={
            isMobile
              ? tt(TICKET_BUTTON_LABEL_BADGE_LABEL_MAP_MOBILE[ticketButtonType])
              : tt(TICKET_BUTTON_LABEL_BADGE_LABEL_MAP_PC[ticketButtonType])
          }
          {...putTiaraObjectProps(buttonEventLog)}
          onClick={onClickButton}
        />
      </div>
      {ticketButtonType === ContentHomeTicketButtonType.Ticket &&
        waitfreeProps && (
          <WaitfreeArea isMobile={isMobile} {...waitfreeProps} />
        )}
    </div>
  );
}

function WaitfreeArea({
  isMobile,
  bm,
  displayPeriodByMinute,
  waitfreeBlockCount,
  isChargedComplete,
  chargedAt,
  baseDate = new Date(),
}: WaitfreeProps) {
  const hasUserWaitfreeInfo = !!chargedAt && !!displayPeriodByMinute;
  const periodText = !displayPeriodByMinute
    ? '-'
    : getPeriodText(displayPeriodByMinute);

  const {waitFreeDialog, showDialog} = useContentHomeWaitFreeDialog({
    isMobile: true,
    periodText,
    bm,
    waitfreeBlockCount,
  });

  return (
    <>
      <div className="mx-15pxr h-1px bg-theme-transparent-10" />
      <div
        className={twMerge(
          'flex h-48px cursor-pointer items-center justify-between px-18pxr',
          !isMobile && 'px-16pxr'
        )}
        onClick={e => LOG_CLICK_EVENT('기다무_클릭', e, showDialog)}
      >
        <div className="flex flex-wrap under-320-view:max-w-[96px] under-320-view:flex-col">
          <Text
            className={twMerge(
              'font-small2-bold mr-4pxr text-ellipsis text-theme-solid-100 line-clamp-1',
              isMobile && 'font-small1-bold'
            )}
          >
            <span>
              {displayPeriodByMinute && getPeriodText(displayPeriodByMinute)}{' '}
              {t('common_ticket_rental_wuf')}
            </span>
          </Text>
          <Text
            className={twMerge(
              'font-small2 text-theme-solid-100 opacity-70 under-320-view:ml-0',
              isMobile && 'font-small1'
            )}
          >
            {t('common_ticket_amount', {
              values: {
                value: isChargedComplete ? 1 : 0,
              },
            })}
          </Text>
        </div>
        <div className="shrink-0">
          {/* 비로그인시 기본 텍스트(지금부터 무료) 표기 */}
          {bm && isWaitfreeBm(bm) && isChargedComplete !== undefined && (
            <>
              {(isChargedComplete || !hasUserWaitfreeInfo) && (
                <div className="flex h-28pxr w-fit-content items-center rounded-5pxr">
                  <Text className="font-small2-bold text-theme-solid-100">
                    {t('contenthome_ep_tab_wuf_charged')}
                  </Text>
                </div>
              )}
              {!isChargedComplete &&
                displayPeriodByMinute &&
                hasUserWaitfreeInfo && (
                  <WaitfreeProgressBar
                    ratio={getRatio(chargedAt, displayPeriodByMinute, baseDate)}
                    remainText={getRemainText(chargedAt, baseDate)}
                  />
                )}
            </>
          )}
        </div>
      </div>
      {waitFreeDialog}
    </>
  );
}

const TICKET_BUTTON_LABEL_BADGE_TYPE_MAP: {
  [key in Exclude<
    ContentHomeTicketButtonType,
    ContentHomeTicketButtonType.StopText
  >]: LabelBadge28Type;
} = {
  [ContentHomeTicketButtonType.Ticket]: LabelBadge28Type.ticket,
  [ContentHomeTicketButtonType.Gift]: LabelBadge28Type.solid,
  [ContentHomeTicketButtonType.Refund]: LabelBadge28Type.refund,
};

const TICKET_BUTTON_LABEL_BADGE_LABEL_MAP_MOBILE: {
  [key in Exclude<
    ContentHomeTicketButtonType,
    ContentHomeTicketButtonType.StopText
  >]: TextTKey;
} = {
  [ContentHomeTicketButtonType.Ticket]: {
    text: '이용권 충전',
    textTKey: 'contenthome_ep_tab_ticket_purchase_button',
  },
  [ContentHomeTicketButtonType.Gift]: {
    text: '선물 받기',
    // @ts-expect-error
    textTKey: '',
  },
  [ContentHomeTicketButtonType.Refund]: {
    text: '이용권 환불',
    textTKey: 'contenthome_ticket_refund_button',
  },
};

const TICKET_BUTTON_LABEL_BADGE_LABEL_MAP_PC: {
  [key in Exclude<
    ContentHomeTicketButtonType,
    ContentHomeTicketButtonType.StopText
  >]: TextTKey;
} = {
  [ContentHomeTicketButtonType.Ticket]: {
    text: '충전',
    textTKey: 'common_cash_charge_button',
  },
  [ContentHomeTicketButtonType.Gift]: {
    text: '받기',
    // @ts-expect-error
    textTKey: '',
  },
  [ContentHomeTicketButtonType.Refund]: {
    text: '환불',
    textTKey: 'contenthome_ep_tab_ticket_refund_button',
  },
};
